export default "__VITE_ASSET__BTTcnHdq__"